module.exports = __webpack_public_path__ + "static/media/get-info-i.16d7c640.svg";